export const I18N_NAMESPACE = 'lists';
